module.exports = __webpack_public_path__ + "img/nigeria.051cbd4.webp";